import { render } from "./DownloadDeepSeek.vue?vue&type=template&id=66d8f244"
import script from "./DownloadDeepSeek.vue?vue&type=script&lang=js"
export * from "./DownloadDeepSeek.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__